import React from "react";
import { notify } from "@/shared/utils/notify";
import { saucesService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ISauce } from "../../../redux/@types";

export const useEditSauce = ({
  sauce,
  onSuccess,
}: {
  sauce: ISauce | undefined;
  onSuccess?: () => void;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    watch,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(yup.object({})),
  });

  const handleSubmit = onSubmit(async (data: any) => {
    if (loading || !sauce) return;

    setLoading(true);
    try {
      await saucesService.patch(sauce.id, {
        name: data.name,
        description: data.description,
        price: data.price,
        path_image: data.path_image || null,
      });
      notify.success(`Se ha actualizado la salsa ${data.name} exitosamente`);
      onSuccess?.();
    } catch (err: any) {
      notify.error(err.message);
    } finally {
      setLoading(false);
    }
  });

  React.useEffect(() => {
    if (sauce) {
      reset({
        name: sauce.name,
        description: sauce.description || "",
        price: sauce.price,
        path_image: sauce.path_image || "",
      });
    }
  }, [sauce, reset]);

  return {
    loading,
    control,
    handleSubmit,
    watch,
    setValue,
  };
};
